module.exports = __webpack_public_path__ + "e0106718/img/revit-icon.5ff0d581.svg";